/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  createRelationLocation,
  getDynamicColumn,
  getMappedWarehouses,
  getRelationLocation,
  getSubModulesByRoleId,
  getUnmappedWarehousesByLevel,
  mapWarehouseToLevel,
  updateRelationLocation,
} from "../../store";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import EditButton from "components/standardized-components/EditButton";
import StandardButton from "components/standardized-components/StandardButton";
import ViewButton from "components/standardized-components/ViewButton";
import { addMinutes, format } from "date-fns";
import Select from "react-select";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForMap = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
};

const styleForPicklistViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  width: { xs: 350, lg: 1000 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const RelationLocation = ({
  getRelationLocation,
  getRelationLocationReducer,
  createRelationLocation,
  updateRelationLocation,
  getUnmappedWarehousesByLevel,
  unmappedWarehousesByLevelReducer,
  getMappedWarehouses,
  mappedWarehousesReducer,
  mapWarehouseToLevel,
  getSubModulesByRoleIdReducer,
  getSubModulesByRoleId,

  getDynamicColumnReducer,

  getDynamicColumn,
  createDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "41778491-500d-4141-b1cc-0053a5a0a98d";

  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let relationLocation = modulesData.find(
    (moduleId) => moduleId.moduleId == "41778491-500d-4141-b1cc-0053a5a0a98d",
  );

  let viewAccess = relationLocation
    ? relationLocation.actionId.includes("102ccfae-c788-4bac-8a7d-59c362e2012b")
    : null;
  let editLocation = relationLocation
    ? relationLocation.actionId.includes("ca5a7fdb-9025-4a3f-89ff-825bee6c43e6")
    : null;

  let mapLocation = relationLocation
    ? relationLocation.actionId.includes("e3d14661-30f9-4cb5-a328-73becd847072")
    : null;

  let viewMappedWarehousesAccess = relationLocation
    ? relationLocation.actionId.includes("a1b9b59c-bc2c-435b-ad2a-f7caed2a8021")
    : null;

  const [state, setState] = useState({
    columns: [
      { Header: "Name", accessor: "rltName", align: "left" },
      { Header: "Level", accessor: "rltLevel", align: "left" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Action",
        accessor: "action",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  useEffect(() => {
    viewAccess && getRelationLocation(jwtToken);
  }, [viewAccess]);

  const [loading, setLoading] = useState(true);
  const [rltId, setRltId] = useState("");
  useEffect(() => {
    let tempRelationLocation = [];
    let data = getRelationLocationReducer.locations.data
      ? getRelationLocationReducer.locations.data
      : [];
    setLoading(getRelationLocationReducer.loading);
    data.map((relationLocation) => {
      const formatDate = new Date(relationLocation.cd);
      const relationLocationObject = {
        rltName: relationLocation.rltName,
        rltLevel: relationLocation.rltLevel,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: relationLocation.cd,
        action: (
          <div style={{ display: "flex" }}>
            {editLocation && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() =>
                  handleOpenUpdateRelationLocationModal(relationLocation)
                }
                style={{ marginRight: "5px", borderRadius: "5px" }}
                size="small"
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
            {viewMappedWarehousesAccess && (
              <ViewButton
                variant="gradient"
                color="info"
                // disabled={!viewMappedWarehousesAccess}
                tooltip="View Mapped Warehouse"
                iconOnly
                type="button"
                style={{ borderRadius: "5px" }}
                size="small"
                onClick={() => {
                  handleOpenViewPicklistModal(relationLocation);
                  getMappedWarehouses(relationLocation.rltId, jwtToken);
                }}
                // disabled={picklist.viewDisable ? true : false}
              >
                <Icon> visibility_icon </Icon>
              </ViewButton>
            )}
            {mapLocation && (
              <StandardButton
                // disabled={!mapLocation}
                tooltip="Map Warehouse"
                style={{ marginLeft: "0.3rem", borderRadius: "5px" }}
                size="small"
                type="button"
                variant="gradient"
                color="success"
                iconOnly
                icon="map"
                onClick={() => {
                  setRltId(relationLocation.rltId);
                  handleOpenAllocateWarehouseModal(relationLocation);
                  getUnmappedWarehousesByLevel(
                    relationLocation.rltId,
                    jwtToken,
                  );
                }}
              >
                {" "}
                <Icon>map</Icon>
              </StandardButton>
            )}
          </div>
        ),
      };
      tempRelationLocation.push(relationLocationObject);
    });
    setState({ ...state, rows: tempRelationLocation });
  }, [getRelationLocationReducer]);

  const [suidTable, setSuidTable] = useState({
    columns: [
      { Header: "warehouse Name", accessor: "warehouseName", align: "left" },

      { Header: "warehouse Code", accessor: "warehouseCode", align: "left" },
    ],
    rows: [],
  });

  const [loading2, setLoading2] = useState(true);

  const { columns: suidColumns, rows: suidRows } = suidTable;
  useEffect(() => {
    let tempGRN = [];
    let data = mappedWarehousesReducer.mappedWarehouses.data
      ? mappedWarehousesReducer.mappedWarehouses.data
      : [];
    setLoading2(mappedWarehousesReducer.loading);
    data.map((singleSuid) => {
      const formatDate = new Date(singleSuid.cd);
      const singleUser = {
        privateKey: singleSuid.suidId,
        warehouseName: singleSuid.warehouseName,
        warehouseCode: singleSuid.warehouseCode,
      };
      tempGRN.push(singleUser);
    });
    setSuidTable({ ...suidTable, rows: tempGRN });
  }, [mappedWarehousesReducer]);

  const [singlePicklist, setSinglePicklistItem] = useState({});

  const [openPicklistViewModal, setOpenPicklistViewModal] = useState(false);

  const handleOpenViewPicklistModal = (picklist) => {
    setSinglePicklistItem(picklist);
    setOpenPicklistViewModal(true);
  };

  const handleCloseViewPicklistModal = () => {
    setOpenPicklistViewModal(false);
  };

  const [relationLocationSelected, setRelationLocationSelected] = useState("");

  const handleRelationLocationChange = (selectedRelationLocation) => {
    setRelationLocationSelected(selectedRelationLocation);
  };

  const relationLocationOptions = [
    {
      label: "Level 1",
      value: 1,
    },
    {
      label: "Level 2",
      value: 2,
    },
    {
      label: "Level 3",
      value: 3,
    },
  ];

  const [createLocationModal, setCreateLocationModal] = useState(false);
  const handleCreateLocationModal = () => {
    setCreateLocationModal(!createLocationModal);

    setRelationLocationSelected("");
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
  };

  const initialValues = {
    rltName: "",
    rltLevel: "",
  };
  const validationSchema = Yup.object({
    rltName: Yup.string().required("Select a name"),
    rltLevel: Yup.object().required("Select a level"),
  });
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");
  const onSubmit = async (values, { resetForm }) => {
    const payload = {
      rltName: values.rltName,
      rltLevel: relationLocationSelected.value,
    };

    let res = await createRelationLocation(payload, jwtToken);
    if (res.status) {
      getRelationLocation(jwtToken);
      setIsSuccess(true);
    }
    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg);
      setIsError(true);
    }

    resetForm();
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [openUpdateRelationLocationModal, setOpenUpdateRelationLocationModal] =
    useState(false);
  const [
    singleRelationLocationDataForUpdate,
    setRelationLocationDataForUpdate,
  ] = useState({});
  const handleOpenUpdateRelationLocationModal = (RelationLocation = {}) => {
    setRelationLocationDataForUpdate(RelationLocation);
    setOpenUpdateRelationLocationModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateRelationLocationModal = () => {
    setOpenUpdateRelationLocationModal(false);
    formikForUpdate.setErrors({});
  };

  useEffect(() => {
    if (isSuccess) {
      setTimeout(() => {
        setIsSuccess(false);
      }, 3000);
    }
  }, [isSuccess]);
  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false);
      }, 3000);
    }
  }, [isError]);

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isErrorForMsgUpdate, setIsErrorForMsgUpdate] = useState("");
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    rltId: singleRelationLocationDataForUpdate.rltId,
    rltName: singleRelationLocationDataForUpdate.rltName,
  };

  const validationSchemaForUpdate = Yup.object({
    rltName: Yup.string().required("Enter the name!"),
  });

  const [editButtonName, setEditButtonName] = useState("Submit");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      id: singleRelationLocationDataForUpdate.rltId,
      rltName: values.rltName.trim(),
    };
    let res = await updateRelationLocation(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getRelationLocation(jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
        handleCloseUpdateRelationLocationModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setIsErrorForMsgUpdate(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [allocateWarehouseModal, setAllocateWarehouseModal] = useState(false);
  const [suidData, setSuidData] = useState(false);

  const handleOpenAllocateWarehouseModal = () => {
    setAllocateWarehouseModal(true);
    formikForMap.setValues(initialValuesForMap);
    formikForMap.setTouched({});
    formikForMap.setErrors({});
    setSelectedWarehouse("");
  };
  const handleCloseAllocateWarehouseModal = () => {
    setAllocateWarehouseModal(false);
    setSelectedWarehouse("");
  };

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  const [createErrorMsg, setCreateErrorMsg] = useState("");
  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [selectedWarehouse, setSelectedWarehouse] = useState("");

  const handleWarehouseChange = (selectedWarehouse) => {
    setSelectedWarehouse(selectedWarehouse);
  };

  const [unmappedWarehouseOptions, setUnmappedWarehouseOptions] = useState([]);

  useEffect(() => {
    let tempUnmappedWarehousesOptions = [];
    let data = unmappedWarehousesByLevelReducer.unmappedWarehouses.data
      ? unmappedWarehousesByLevelReducer.unmappedWarehouses.data
      : [];
    data.map((document) => {
      tempUnmappedWarehousesOptions.push({
        label: document.warehouseName,
        value: document.warehouseCode,
        warehouseId: document.warehouseId,
      });
    });
    setUnmappedWarehouseOptions(tempUnmappedWarehousesOptions);
  }, [unmappedWarehousesByLevelReducer]);

  const initialValuesForMap = {
    warehouse: "",
  };

  const [releaseButtonName, setReleaseButtonName] = useState("Submit");
  const onSubmitForMap = async (values) => {
    setReleaseButtonName("Please wait...");
    let payload = {
      warehouseIds: selectedWarehouse,
      rltId: rltId,
    };

    let res = await mapWarehouseToLevel(payload, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getRelationLocation(jwtToken);
      setTimeout(() => {
        setReleaseButtonName("Submit");
        handleCloseAllocateWarehouseModal();
      }, 3000);
    }
    if (!res.status) {
      setCreateErrorMsg(res?.data?.data?.msg);
      setIsErrorAllocateItem(true);
      setReleaseButtonName("Submit");
    }
  };

  const formikForMap = useFormik({
    initialValues: initialValuesForMap,
    onSubmit: onSubmitForMap,
  });

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getRelationLocation(jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
              <Modal
                open={createLocationModal}
                onClose={handleCreateLocationModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Create Relation Location
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateLocationModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">Name</MDTypography>

                        <MDInput
                          type="text"
                          name="rltName"
                          fullWidth
                          autoComplete="off"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.rltName}
                          error={
                            formik.touched.rltName &&
                            formik.errors.rltName &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                            maxLength: 45,
                          }}
                        />

                        {formik.touched.rltName && formik.errors.rltName && (
                          <TextError msg={formik.errors.rltName} />
                        )}
                      </MDBox>

                      <MDBox mb={2}>
                        <MDTypography variant="h6">Level</MDTypography>
                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="rltLevel"
                          onBlur={() => {
                            formik.handleBlur({
                              target: { name: "rltLevel" },
                            });
                          }}
                          value={relationLocationSelected}
                          options={relationLocationOptions}
                          onChange={(selectedOption) => {
                            handleRelationLocationChange(selectedOption);
                            formik.setFieldValue("rltLevel", selectedOption);
                          }}
                        />
                        {formik.touched.rltLevel && formik.errors.rltLevel && (
                          <TextError msg={formik.errors.rltLevel} />
                        )}
                      </MDBox>
                      <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Location Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={!formik.isValid}
                        >
                          Submit
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openUpdateRelationLocationModal}
                onClose={handleCloseUpdateRelationLocationModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Update
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseUpdateRelationLocationModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">Name</MDTypography>
                        <MDInput
                          type="text"
                          name="rltName"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForUpdate.handleBlur}
                          onChange={formikForUpdate.handleChange}
                          value={formikForUpdate.values.rltName}
                          error={
                            formikForUpdate.touched.rltName &&
                            formikForUpdate.errors.rltName &&
                            true
                          }
                          inputProps={{
                            maxLength: 45,
                          }}
                        />
                        {formikForUpdate.touched.rltName &&
                          formikForUpdate.errors.rltName && (
                            <TextError msg={formikForUpdate.errors.rltName} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {isErrorForMsgUpdate}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Relation location updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={
                            !formikForUpdate.isValid ||
                            editButtonName === "Please wait..."
                          }
                        >
                          {editButtonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={allocateWarehouseModal}
                onClose={handleCloseAllocateWarehouseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForMap}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Map
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateWarehouseModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForMap.handleSubmit}
                    >
                      <MDBox mb={1}>
                        <MDTypography
                          variant="h6"
                          style={{ fontWeight: "500" }}
                        >
                          {" "}
                          Warehouse
                        </MDTypography>

                        <Select
                          isClearable
                          isMulti
                          className="select-css"
                          maxMenuHeight={100}
                          placeholder="Choose one..."
                          name="warehouse"
                          onBlur={() => {
                            formikForMap.handleBlur({
                              target: { name: "warehouse" },
                            });
                          }}
                          value={selectedWarehouse}
                          options={unmappedWarehouseOptions}
                          onChange={(selectedOption) => {
                            handleWarehouseChange(selectedOption);
                            formikForMap.setFieldValue(
                              "warehouse",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForMap.touched.warehouse &&
                          formikForMap.errors.warehouse && (
                            <TextError msg={formikForMap.errors.warehouse} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {createErrorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Warehouse mapped successfully
                          </Alert>
                        </Collapse>
                      </MDBox>

                      <MDBox mt={3}>
                        <MDButton
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={
                            !formikForMap.isValid ||
                            releaseButtonName === "Please wait..."
                          }
                        >
                          {releaseButtonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openPicklistViewModal}
                onClose={handleCloseViewPicklistModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForPicklistViewModal}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Mapped Warehouses
                    </MDTypography>

                    <MDBox>
                      <span>
                        <Tooltip title="Close">
                          <IconButton
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                              marginBottom: "5px",
                            }}
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseViewPicklistModal}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />

                  <MDBox>
                    {!loading2 ? (
                      <DataTable
                        table={{ columns: suidColumns, rows: suidRows }}
                        isSorted={true}
                        tableSearch={true}
                        entriesPerPage={{
                          defaultValue: 5,
                          entries: [5, 10, 15, 20, 25, 30],
                        }}
                        showTotalEntries={true}
                        noEndBorder
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "100px",
                          marginBottom: "100px",
                        }}
                      >
                        <CircularProgress color="info" />
                      </div>
                    )}
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getRelationLocationReducer: state.getRelationLocationReducer,
    unmappedWarehousesByLevelReducer: state.unmappedWarehousesByLevelReducer,
    mappedWarehousesReducer: state.mappedWarehousesReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    createRelationLocation: (payload, jwtToken) =>
      dispatch(createRelationLocation(payload, jwtToken)),
    updateRelationLocation: (payload, jwtToken) =>
      dispatch(updateRelationLocation(payload, jwtToken)),
    getUnmappedWarehousesByLevel: (rltId, jwtToken) =>
      dispatch(getUnmappedWarehousesByLevel(rltId, jwtToken)),
    mapWarehouseToLevel: (payload, jwtToken) =>
      dispatch(mapWarehouseToLevel(payload, jwtToken)),
    getMappedWarehouses: (rltId, jwtToken) =>
      dispatch(getMappedWarehouses(rltId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RelationLocation);
